var render = function render(){var _vm=this,_c=_vm._self._c;return _c('window',{attrs:{"title":"Geochart"}},[_c('vue-chart',{attrs:{"chart-type":"GeoChart","columns":_vm.columns,"rows":_vm.rows,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }